// extracted by mini-css-extract-plugin
module.exports = {"list":"link-list-list--b26ee"};